<template>
  <section id="home">
    <v-container fluid fill-height class="home">
      <v-layout justify-center align-center column pa-5>

        <div class="py-12"></div>
        <div class="py-8"></div>

        <div class="font-weight-black black--text left: 50%" :class="[$vuetify.breakpoint.smAndDown? 'display-2' : 'display-4']">{{ $t('startTitle') }}</div>
        <div class="display-1 font-weight-bold black--text">{{ $t('startSubtitle') }}</div>
        <v-btn color=black class="hidden-sm-and-down  mt-16"  fab outlined @click="$vuetify.goTo('#services')">
          <v-icon color=black>mdi-chevron-double-down</v-icon>
        </v-btn>
        <div class="py-12"></div>
        <div class="py-12"></div>
        <div class="py-12"></div>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style scoped>
</style>